import React, { useState } from "react";
import { Box, Divider, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpensesTable from "./ExpensesTable";
import ComprehensiveSaleReport from "./ComprehensiveSaleReport";
import ComprehensivePurchaseReport from "./ComprehensivePurchaseReport";
import AccountGeneralReport from "./AccountGeneralReport";

const ReportsIndex = () => {
  const { t } = useTranslation();

  // Tabs
  const [value, setValue] = useState(0);
  const [selectedBranch, setSelectedBranch] = useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {/* Header */}
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" },
            mb: 2,
            gap: 0,
          }}
        >
          <Box>
            <Typography variant="h4">{t("ReportIndex.pageTitle")}</Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {t("payroll.dataLoadedOn")} {new Date().toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider />

      {/* Tabs */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          px: 2,
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: 370, sm: 600, md: 900, lg: 1200 },
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab value={0} label={t("ReportIndex.customerReport", "Customer Report")} />
            <Tab value={1} label={t("ReportIndex.supplierReport", "Supplier Report")} />
            <Tab value={2} label={t("ReportIndex.expenses", "Expenses")} />
            <Tab value={3} label={t("ReportIndex.accountGeneral", "Account General Report")} />
          </Tabs>
        </Box>
      </Box>

      <Divider />

      {/* Data Tables */}
      <Box p={2}>
        <Box mb={4}>
          {value === 0 && (
            <ComprehensiveSaleReport
              selectedBranch={selectedBranch}
              setSelectedBranch={setSelectedBranch}
            />
          )}
          {value === 1 && <ComprehensivePurchaseReport selectedBranch={selectedBranch} />}
          {value === 2 && <ExpensesTable />}
          {value === 3 && <AccountGeneralReport />}
        </Box>
      </Box>
    </>
  );
};

export default ReportsIndex;
